import React, { useEffect, useState } from "react";
import "./addorderstatusStyle.scss";

import { add_order_status } from "../../../Component/dummydata";

import { ChargeOrderModal } from "./ChargeOrderModal/ChargeOrderModal";
import { convert_to_am_pm } from "../../../API/API";

const order_statuses = [
  // "All",
  "Pickup Requested",
  "Driver Enroute to Pickup",
  "Picked Up",
  "Customer Charged",
  "Deliver Clothes",
  "Driver Enroute to Dropoff",
  // "Order Cancelled",
  "Order Completed",
];

export const AddOrderStatus = ({
  data,
  total,
  payment_details,
  setpayment_details,
  setloader,
}) => {
  const [payment_modal, setpayment_modal] = useState(false);
  const [charge_deliver_modal, setcharge_deliver_modal] = useState(false);
  const [complete_deliver_modal, setcomplete_deliver_modal] = useState(false);
  const [delivery_modal, setdelivery_modal] = useState(false);
  const [filtered_status, setfiltered_status] = useState({});
  const [last_status, setlast_status] = useState(-1);
  useEffect(() => {
    let temp_status = [...data.status_order_data];
    // let temp_status = [
    //   {
    //     stage: "Pickup Requested",
    //     created_at: "2022-09-11T13:15:56.000Z",
    //   },
    //   {
    //     stage: "Customer Charged",
    //     created_at: "2022-09-02T13:15:56.000Z",
    //   },
    //   {
    //     stage: "Driver Enroute to Pickup",
    //     created_at: "2022-09-20T13:15:56.000Z",
    //   },
    //   {
    //     stage: "Driver Enroute to Pickup",
    //     created_at: "2022-09-09T13:15:56.000Z",
    //   },
    // ];
    let last_status_index = -1;
    let temp_obj = {};
    temp_status.map((el) => {
      let { stage, created_at } = el;
      let name = stage == "Order Charged" ? "Customer Charged" : stage;
      if (!temp_obj[name]) {
        temp_obj[name] = created_at;
        let index = order_statuses.indexOf(name);
        if (index > last_status_index) {
          last_status_index = index;
        }
      }
    });
    setlast_status(last_status_index);
    setfiltered_status({ ...temp_obj });
  }, []);
  return (
    <div className="addorderstatus">
      {data.status_order_data && (
        <div className="left_side">
          {order_statuses.map((el, i) => {
            // return;
            // if (i % 2) {
            //   return;
            // }
            if (
              (!data.address || data.address == "no, no, no") &&
              ["Deliver Clothes", "Driver Enroute to Dropoff"].indexOf(el) != -1
            ) {
              return;
            }
            if (
              (el == "Pickup Requested" &&
                !filtered_status["Pickup Requested"]) ||
              (el == "Driver Enroute to Pickup" &&
                !filtered_status["Pickup Requested"])
            ) {
              return;
            }

            return (
              <div className="status_tabs">
                <div
                  className="status_orbs"
                  title={i + "_" + last_status}
                  state={
                    i < last_status ? "0" : i == last_status ? "1" : "none"
                  }
                ></div>
                <div className="status_type">
                  <div>{el}</div>
                  <div className="status_time">
                    {filtered_status[el]
                      ? convert_to_am_pm(filtered_status[el])
                      : i < last_status && "no data"}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {/* <div className="status_btn_group">

        {payment_details.payed || data.charged == "1" ? (
          <>
            {(data.delivered == "0" ||
              data.file_data.payment_details.payed_as.delivery == "0") && (
              <>
                {data.address && (
                  <div
                    className="btn"
                    type="type2"
                    onClick={() => setdelivery_modal(true)}
                  >
                    Start Delivery
                  </div>
                )}
              </>
            )}
            <div
              className="btn"
              type="type2"
              onClick={() => setcomplete_deliver_modal(true)}
            >
              Mark as completed
            </div>
          </>
        ) : (
          <>
            <div
              className="btn"
              type="type2"
              onClick={() => setpayment_modal(true)}
            >
              Charge Order
            </div>
            {data.address && (
              <div
                className="btn"
                type="type2"
                onClick={() => setcharge_deliver_modal(true)}
              >
                Charge & Deliver
              </div>
            )}
          </>
        )}
      </div> */}
      {/* <div
          className="btn"
          type="type2"
          onClick={() => {
            // settag_ids([...tag_ids.filter(el => (el.order_id != '' && el.order_item != 'Select One...') && el)]);
            // // settag_ids([...tag_ids.filter=>])
            // setadd_order_current_showing("add_order_menu_images");
          }}
          >
          Print Ticket 
        </div> */}
      {/* {(payment_modal || charge_deliver_modal) && (
        <ChargeOrderModal
          delivery={charge_deliver_modal}
          data={data}
          setpayment_modal={
            charge_deliver_modal ? setcharge_deliver_modal : setpayment_modal
          }
          total={total}
          payment_details={payment_details}
          setpayment_details={setpayment_details}
          setloader={setloader}
        />
      )}
      {(delivery_modal || complete_deliver_modal) && (
        <TempDeliveryModal
          delivery={delivery_modal}
          data={data}
          cancel={() =>
            complete_deliver_modal
              ? setcomplete_deliver_modal(false)
              : setdelivery_modal(false)
          }
          setloader={setloader}
        />
      )} */}
    </div>
  );
};
